export default "__VITE_ASSET__CAzr7jSy__"